import { AxiosInstance } from 'axios'

import { createAxios } from './createAxios'

export const axiosWithToken: AxiosInstance = createAxios()

export const axiosWithFile: AxiosInstance = createAxios({ withFile: true })
